import { render } from "./MWAboutPage.vue?vue&type=template&id=7c5a5f30&scoped=true"
import script from "./MWAboutPage.vue?vue&type=script&lang=js"
export * from "./MWAboutPage.vue?vue&type=script&lang=js"

import "./MWAboutPage.vue?vue&type=style&index=0&id=7c5a5f30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5a5f30"]])

export default __exports__